/**
 * URL para abrir la carpeta en Google Drive.
 *  - Si el expediente tiene guardado su `driveFolderId` (poblado una vez con los
 *    IDs de las unidades), es un enlace DIRECTO a la carpeta: abre al instante.
 *  - Si por algo no lo tuviera (expediente creado después), cae a una búsqueda
 *    simple de Drive en la sesión del usuario. Nunca depende de otra app.
 */
export function urlCarpetaDrive(exp: { radicado: string; driveFolderId?: string | null }): string {
  if (exp.driveFolderId) return `https://drive.google.com/drive/folders/${exp.driveFolderId}`;
  return `https://drive.google.com/drive/search?q=${encodeURIComponent(exp.radicado.trim())}`;
}
